import type { RouteRecordRaw } from 'vue-router'

const MainLayout = () => import('@/layouts/MainLayout.vue')

export const ROOT_ROUTE_REDIRECT_PATH = '/welcome'
export const rootRoute: RouteRecordRaw = {
  path: '/',
  name: 'home',
  redirect: ROOT_ROUTE_REDIRECT_PATH,
  component: MainLayout,
  children: [],
}
